import { TagsOutlined } from '@ant-design/icons';
import { NavItemType } from 'types/menu';

const icons = {
  TagsOutlined
};

// ==============================|| MENU ITEMS - FORMS & TABLES ||============================== //

const tags: NavItemType = {
  id: 'group-tags',
  title: 'Tags',
  icon: icons.TagsOutlined,
  type: 'group',
  children: [
    {
      id: 'tags',
      title: 'Tags',
      type: 'collapse',
      icon: icons.TagsOutlined,
      children: [
        {
          id: 'contacts',
          title: 'Contacts',
          type: 'item',
          url: '/tags/contacts'
        }
      ]
    }
  ]
};

export default tags;
